
//////////////////////////////////////////////
//! Static Map generator form ACF fields
//////////////////////////////////////////////

/* :::::::::::::::::::::::::::::::::::::::::::
	# VIEW $ARGS

	filters = [], 		/ Array of DOM ids for filter objects
	masterFilter = '' 	/ ID of master filter
	queries = {} 		/ Current queries object from app
	dispatcher = {}		/ app.dispatcher object
::::::::::::::::::::::::::::::::::::::::::: */

/* :::::::::::::::::::::::::::::::::::::::::::
	# VIEW GUIDE

	## Init
	1. Check if there are queries.
	2. Update filters to match
	3. Find all sets of filters in DOM

	## MASTER CLICK
	1. Reset all other filters
	2. send EVENT to app

	## FILTER CLICK
	1. for each filter (in all sets) check for compatible posts
	2. if no match disable filter
	2. send EVENT to app

	## FILTER SAME CLICK
	1. Set current group to -1
	2. send EVENT to app

	EVENT TO APP DATA STRUCTURE

	[this.queries]

::::::::::::::::::::::::::::::::::::::::::: */

portfolioFilters = function(filters, masterFilter, queries, instantMode ,dispatcher) {

//::::::::::::::::::::::::::::::::::::::::::::
//! STATIC VARS
//::::::::::::::::::::::::::::::::::::::::::::

	this.masterFilter = 	masterFilter;
	this.instantMode = instantMode;

	this.taxonomy = {};
	this.filters = filters;
	this.queries = queries;
	this.postsAll = {};
	this.postsFiltered = {};
	this.postsTaxonomies = {};

	//alert(this.filters);

//::::::::::::::::::::::::::::::::::::::::::::
//! DYNAMIC VARS
//::::::::::::::::::::::::::::::::::::::::::::


//////////////////////////////////////////////
	this.init();
//////////////////////////////////////////////

};

portfolioFilters.prototype = {

	constructor: portfolioFilters,

//////////////////////////////////////////////
//! INITIALIZER
//////////////////////////////////////////////
	init : function() { //console.log('#FILTERS INIT');

		this.bindEvents();

		// get Taxonomy Data trees
		for (i=0; i < this.filters.length; i++ ) {

			this.getTaxData(this.filters[i]);
		}
		//this.getTaxData('location_prime');

		//this.showSubfilterAuto(); // check filter trees for preselected filters and show/hide sub menus
	},

//////////////////////////////////////////////
//! EVENT HANDLERS
//////////////////////////////////////////////
	bindEvents: function(){
		//console.log('## FILTER EVENTS LOADING');
//::::::::::::::::::::::::::::::::::::::::::::
//! LISTEN FOR POSTS LIST LOAD
//::::::::::::::::::::::::::::::::::::::::::::



		// Listen for post data load
		app.dispatcher.addEventListener(EVENTS.API.LOAD+'_portfolio', function(e, d){

			this.postsAll = d; // store the posts

			//console.log(this.posts);
			this.checkPosts(function(){ // check the posts..

				for (i=0; i < this.filters.length; i++) {

					this.checkFilters(this.filters[i], null);
				}


					this.enableUI(true); // enable UI


			}.bindX(this));

		}.bindX(this));

		// Listen for Taxonomy Data loads

		for (i=0; i < this.filters.length; i++ ) {

			app.dispatcher.addEventListener(EVENTS.API.LOAD+'_taxonomy_'+this.filters[i], this.addTaxData.bindX(this));

		}



		app.dispatcher.addEventListener(EVENTS.API.FAILED, function(e){ alert('API FIALED')}.bindX(this));




//::::::::::::::::::::::::::::::::::::::::::::
//! Change events for filters
//::::::::::::::::::::::::::::::::::::::::::::

		// listen for location selections in map to check filters tree for sub muenus
		//app.dispatcher.addEventListener(EVENTS.MAP.NEWLOCATION, this.showSubfilterAuto.bindX(this));

		// Click evemts for filters
		for (i=0; i < this.filters.length; i++ ) {

			this.filterChange(this.filters[i]);
		}

		app.dispatcher.addEventListener(EVENTS.MAP.RESET, this.clearAllFilters.bindX(this));

//::::::::::::::::::::::::::::::::::::::::::::
//! APPLY BUTTON
//::::::::::::::::::::::::::::::::::::::::::::

		$(DOM.filtersBar.apply+'-1, '+DOM.filtersBar.apply+'-2').click(function(){

			window.location = this.getUrl();
			app.modalCLose();

		}.bindX(this));

//::::::::::::::::::::::::::::::::::::::::::::
//! CLEAR BUTTON
//::::::::::::::::::::::::::::::::::::::::::::
		$(DOM.filtersBar.clear+'-1,'+DOM.filtersBar.clear+'-2').click(function(){

			this.clearAllFilters();

		}.bindX(this))


		app.dispatcher.addEventListener(EVENTS.MAP.RESET, this.clearAllFilters.bindX(this));


//::::::::::::::::::::::::::::::::::::::::::::
//! Toggle Button
//::::::::::::::::::::::::::::::::::::::::::::

		$(DOM.filtersBar.viewTogg).click(function(e){

			e.preventDefault();
			//alert('hi');


			//console.log($(e.target));
			var href = $(e.currentTarget).data('target');
			//alert(href);

			var url = this.getUrl(href);

			//alert(url);
			window.location = url;


		}.bindX(this))


//::::::::::::::::::::::::::::::::::::::::::::
//! Manual Sub menus showHide
//::::::::::::::::::::::::::::::::::::::::::::

		$('.btn-radioFilter__arrow').click(function(e){

			var $this = $(e.target).closest('li');

			this.showSubfilterManual($this);

		}.bindX(this))

	},



//////////////////////////////////////////////
//! TAXONOMY DATA
//////////////////////////////////////////////

//::::::::::::::::::::::::::::::::::::::::::::
//! BMNAME
//::::::::::::::::::::::::::::::::::::::::::::
	getTaxData:function(taxName){

		// GET TAXONOMY DATA TREES


			var query = app.wp.siteUrl+'/wp-json/wp/v2/'+taxName+'?per_page=100&fields=id,slug,count,taxonomy,name';


			app.loadRestPosts('taxonomy_'+taxName, query);


	},

//::::::::::::::::::::::::::::::::::::::::::::
//! addTaxData - Save the taxonomy data
//::::::::::::::::::::::::::::::::::::::::::::
	addTaxData:function(e, d) {
		//console.log('FETCHING TAXONOMY: ' );
		// console.log(d);

		var tax_name = d[0].taxonomy;

		//alert(d[0].taxonomy);

		this.taxonomy[tax_name] = d;
	},

//::::::::::::::::::::::::::::::::::::::::::::
//! BMNAME
//::::::::::::::::::::::::::::::::::::::::::::


//////////////////////////////////////////////
//! CHECKS   this.postsTaxonomies = {};
//////////////////////////////////////////////

//::::::::::::::::::::::::::::::::::::::::::::
//! CheckPosts - check posts list against queries
//::::::::::::::::::::::::::::::::::::::::::::
	checkPosts: function(callback){

		//console.log('##CHECKING ALL POSTS');

		// 1. setup storage for matched posts and filter terms
		var postsMatched = [];
		var filtersMatched = [];

		// 2. Setup arrays for each filter group
		for (i=0; i < this.filters.length; i++) {

			var thisFilter = this.filters[i];
			filtersMatched[thisFilter] = [];
		}

		// 3. Search each post
		jQuery.grep(this.postsAll, function(post, index) {

			// 3a. Setup match state for post and storage for its filters
			var postMatched = true;
			var postFilters = [];

			// 3b. Cycle each filter type
			for (i=0; i < this.filters.length; i++) {

				var thisFilter = this.filters[i];

				postFilters[thisFilter] = post[thisFilter]; // get all posts filter ids
				postFilters[thisFilter].push(-1); // add ALL id tax to lists

				// Check current tax query agaianst post tax list
				if ( jQuery.inArray(this.queries[thisFilter][0],  postFilters[thisFilter]) === -1 ) {

					postMatched = false; // if not detected flag post to be not included
				}
			}

			// 3c ADD post and taxonoimies to matched lists
			if (postMatched) {

				postsMatched.push(post); // add post

				// cycle filters
				for (i=0; i < this.filters.length; i++) {

					var thisFilter = this.filters[i];

					jQuery.merge(filtersMatched[thisFilter], postFilters[thisFilter]); // add taxonomies to Matched list
				}
			}
		}.bindX(this));

		// cycle the matched taxonomies
		for (i=0; i < this.filters.length; i++) {
			var thisFilter = this.filters[i];

			jQuery.unique(filtersMatched[thisFilter]); // get rid of duplicates

		}

		// 4. Push results to VIEW
		this.postsFiltered = postsMatched; // send filtered list to view
		this.postsTaxonomies = filtersMatched; // send taxonomies to view

		//console.log(this.postsFiltered);
		//console.log(this.postsTaxonomies);

		// 5. do callback
		callback();
	},

//::::::::::::::::::::::::::::::::::::::::::::
//! CheckFilters - check posts list against queries
//::::::::::::::::::::::::::::::::::::::::::::

	checkFilters: function(currentFilter, callback){

		//console.log('## CHECKING FILTERS');

		// Cycle filters
		for (i=0; i < this.filters.length; i++) {


			var thisFilter = this.filters[i];

			//console.log(thisFilter);
			//console.log(thisFilter);
			//alert(thisFilter + ' / ' + currentFilter );


			//alert(thisFilter != currentFilter)

			// Ignore if master filter
			if ( (thisFilter != currentFilter) && (thisFilter != this.masterFilter) ) {
				//alert('checking: '+ thisFilter);
				var filterGrp = thisFilter+'_group'; // group name
				var $filters = $('input:checkbox[name='+DOM.filtersBar[filterGrp]+']'); // DOM objects

				// Check each filter in group
				$filters.each(function(index, element){

					var termID = parseInt($(element).val()); // get the term val from DOM

					// Check if the Dom term is is available under current filters
					if (	jQuery.inArray(termID, this.postsTaxonomies[thisFilter]) !== -1) {

						this.enableFilter($(element)); // Enable the checkbox
					} else {

						this.disableFilter($(element)); // Disbale the checkbox
					}

				}.bindX(this))
			} else {
				//alert('Skip Check:' + thisFilter);
			}
		}

		if (callback) {
			callback();
		}


	},

//////////////////////////////////////////////
//! FILTER TASKS
//////////////////////////////////////////////

//::::::::::::::::::::::::::::::::::::::::::::
//! filterChange (When a filter is changed)
//::::::::::::::::::::::::::::::::::::::::::::
	filterChange:function(filter) { //console.log('## FILTER CHANGING');

		//this.enableUI(false); // disable UI

		var grp = DOM.filtersBar[ filter+'_group' ];

		$('input:checkbox[name='+grp+']').change(function(e){

			//alert('FILTER CHANGING: '+ filter);

			var $this = e.target; // set target

			//alert($($this));
			//alert(filter + ' / ' + $this.value);

			// Radio button behaivour for checkboxes
			$('input:checkbox[name='+grp+']').prop('checked', false);
			$($this).attr('checked', true);

			this.updateQuery(filter, $this.value, true); // update the view query value and send Event to APP
			//this.tidyFilters(filter); // scan for available options in filters

			if (filter == this.masterFilter) {


				for (i=0; i < this.filters.length; i++) {

					if (this.filters[i] != this.masterFilter) {

						this.resetFilter(this.filters[i]);
					}

				}

			}

			//this.showSubfilterAuto();

			if (this.instantMode) { this.updateTags();}

			this.checkPosts(function(){ // check the posts..

				//alert();

				this.checkFilters(filter, function(){ // check the filters

					//this.enableUI(true); // enable UI

				}.bindX(this));
			}.bindX(this));

			// Recheck the Filters Tree to show sub menus


		}.bindX(this));


/*
			this.checkPosts(function(){ // check the posts..

				this.checkFilters(function(){ // check the filters

					this.enableUI(true); // enable UI

				}.bindX(this));
			}.bindX(this));
*/

	},

//////////////////////////////////////////////
//! QUERY TASKS
//////////////////////////////////////////////

//::::::::::::::::::::::::::::::::::::::::::::
//! updateQuery
//::::::::::::::::::::::::::::::::::::::::::::
	updateQuery: function(filter, value, push){

		value = parseInt(value);

		this.queries[filter] = [value];

		if (push) {

			this.pushQuery();
		}


	},

	pushQuery: function(){

		// If instant mode (map) push the new query params staright to the addreesbar (no refresh)
		if (this.instantMode) {

			var url = this.getUrl();
			history.pushState(null, "", url);
		}

		//console.log('## EVENT FILTER QUERY CHANGE');
		//console.log(this.queries);
		app.dispatcher.dispatch(EVENTS.FILTERS.CHANGE, this.queries );


		if (this.instantMode) {
			this.enableUI(false);

			setTimeout(function(){
				this.enableUI(true);

			}.bindX(this), 500);
		}

	},

//////////////////////////////////////////////
//! DOM TASKS
//////////////////////////////////////////////

//::::::::::::::::::::::::::::::::::::::::::::
//! enableUI - toggle ui interactivity
//::::::::::::::::::::::::::::::::::::::::::::

	enableUI: function(enable) {
		//alert('ENABLEING UI');
		if (enable) {
			$(DOM.filtersBar.mdl).removeClass('is-loading');
		} else {
			$(DOM.filtersBar.mdl).addClass('is-loading');
		}

	},

//::::::::::::::::::::::::::::::::::::::::::::
//! enableFilter - make a filter box clickable
//::::::::::::::::::::::::::::::::::::::::::::
	enableFilter:function($radio) {

		$radio.removeAttr('disabled');
		$radio.parent().removeClass('is-disabled');
	},

//::::::::::::::::::::::::::::::::::::::::::::
//! enableFilter - make a filter box unclickable
//::::::::::::::::::::::::::::::::::::::::::::
	disableFilter:function($radio) {

		$radio.attr('disabled', true);
		$radio.parent().addClass('is-disabled');
	},

//::::::::::::::::::::::::::::::::::::::::::::
//! resetFilter - reset a filter group to it 'ALL' state
//::::::::::::::::::::::::::::::::::::::::::::
	resetFilter: function(filter){
		//alert('resetting: '+filter);
		var grp = DOM.filtersBar[ filter+'_group' ];
			//console.log(grp);
			$('input:checkbox[name='+grp+']').prop('checked', false);
			$('input:checkbox[name='+grp+']').first().attr('checked', true);

			this.updateQuery(filter, -1, false);

	},

//::::::::::::::::::::::::::::::::::::::::::::
//! BMNAME
//::::::::::::::::::::::::::::::::::::::::::::
	clearAllFilters: function() {
		this.enableUI(false);


			for (i=0; i < this.filters.length; i++ ) {

				//alert('TRYT TO CLEAR: '+this.filters[i]);

				this.resetFilter(this.filters[i]);
			}

			if (this.instantMode) { this.updateTags(); }

			this.checkPosts(function(){ // check the posts..

				this.checkFilters(null, function(){ // check the filters

					this.pushQuery();
					this.enableUI(true); // enable UI

				}.bindX(this));
			}.bindX(this));

			app.dispatcher.dispatch(EVENTS.FILTERS.CLEAR);
			//this.showSubfilterAuto();
	},

//::::::::::::::::::::::::::::::::::::::::::::
//! Get url for a query
//::::::::::::::::::::::::::::::::::::::::::::
	getUrl: function(url){

		//console.log('## FETCHING URL');

		if (!url) {
			url = window.location.href;
		}

		var re1 = new RegExp('\\?.*', 'i');;
		url = url.replace(re1, '');

		var newQuery = '?';


		// for each active filter..
		for (i=0; i < this.filters.length; i++) {

			var tax = this.filters[i]; // get the Tax Name
			var term = this.queries[tax][0]; // Get the Term id
			var slug = '';

			// Check there is a term to look up...
			if (term != -1) {
				//console.log(this.filters[i] + ' is set too: '+ this.queries[tax][0]);
				// check each term in the tax
				for (j=0; j < this.taxonomy[tax].length; j++) {

					//alert('MATCHING ID TO SLUG');
					var id = this.taxonomy[tax][j].id; // get the id

					// if id's match
					if (term == id ) { // compare id to requeired term
						//alert('## FETCHING SLUG: ' + this.taxonomy[tax][j]['slug']);
						// get the slug
						slug = this.taxonomy[tax][j]['slug'];

						//console.log('MATCHING TERM IN '+ tax + ' RETURNING SLUG '+ slug);
					}
				}

				// Add to query
				newQuery = newQuery + tax + '=' + slug+'&';
			}
		}



		// Make url
		url = url +  newQuery;

		// Trim any trailing `&` symbols from url
		var re2 = new RegExp('[\?|&]$','i')
		url = url.replace(re2, '');

		// send url
		return url;

	},

//::::::::::::::::::::::::::::::::::::::::::::
//! update tags
//::::::::::::::::::::::::::::::::::::::::::::
	updateTags: function(){

		$(DOM.filtersBar.tags + ' span').remove();

		var qApplied = 0;

		for (i=0; i < this.filters.length; i++) {

			var thisFilter = this.filters[i];


			if (this.queries[thisFilter][0] != -1) {
				jQuery.grep(this.taxonomy[thisFilter], function(tax,i){
					console.dir(tax);
					if ( tax.id == this.queries[thisFilter][0] ) {

						qApplied ++;

						$(DOM.filtersBar.tags).append('<span class="ui-filterBar__showing__tag" data-tax="'+tax.taxonomy+'">'+tax.name+'</span>');

					}

				}.bindX(this));
			}
		}

		if ( qApplied == 0) {
			$(DOM.filtersBar.tags).append('<span class="ui-filterBar__showing__tag">All</span>');
		}

	},

//::::::::::::::::::::::::::::::::::::::::::::
//! Manual ShowHideSub Menus
//::::::::::::::::::::::::::::::::::::::::::::
	showSubfilterManual: function(el){

		if ($(el).hasClass('is-open')) {
			$(el).removeClass('is-open');
		} else {
			$(el).addClass('is-open');
		}

	},

//::::::::::::::::::::::::::::::::::::::::::::
//! Check the filters trees to hide and show sum menus
//::::::::::::::::::::::::::::::::::::::::::::
	showSubfilterAuto: function(){

		$('#js-filters-mdl li').each(function(){
			$(this).removeClass('is-open');

			$(this).has('input:checked').addClass('is-open');

		});

	},

}; // END VIEW